import {useState} from 'react';
import {Input, Modal} from 'antd';

const {TextArea} = Input;

export const TransactionTextWidget = ({title, value, placeholder, onTextChange, maxLength, maxRows, props}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const defaultStartValue = ((value === null) || (value.length === 0)) ? "" : value;
    const [textVal, setTextVal] = useState(defaultStartValue);

    const onClick = () => {
        setIsModalOpen(true);
    }

    const onModalCancel = () => {
        setIsModalOpen(false);
    }

    const onModalOk = () => {
        if (onTextChange) {
            onTextChange(textVal);
        }
        setIsModalOpen(false);
    }

    const onChange = (e) => {
        setTextVal(e.target.value);
    }

    if (placeholder === undefined) {
        placeholder = "text";
    }

    maxLength = maxLength ? maxLength : 512
    maxRows = maxRows ? maxRows: 4;

    const defaultValue = textVal.length === 0 ? `${placeholder} (click to edit)` : textVal;

    return <div>
        <div onClick={onClick} style={{cursor: 'pointer', margin: "5px"}}>{defaultValue}</div>
        <Modal open={isModalOpen} onCancel={onModalCancel} onOk={onModalOk}>
            <b>{title}</b><p/>
            <TextArea value={textVal} rows={maxRows} maxLength={maxLength} placeholder={placeholder} onChange={onChange}/>
        </Modal>
    </div>
}